(function () {

  /* =========================================================
     GET FIELD VALUE
  ========================================================= */

  function getFieldValue(placeholders) {
    var fields = document.querySelectorAll('input, textarea, select');

    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];
      var placeholder = (field.placeholder || '').trim().toLowerCase();

      for (var j = 0; j < placeholders.length; j++) {
        if (placeholder === placeholders[j].toLowerCase()) {
          return (field.value || '').trim();
        }
      }
    }

    return '';
  }


  /* =========================================================
     HTML SAFE
  ========================================================= */

  function safe(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }


  /* =========================================================
     GET CURRENT FORM DATA
  ========================================================= */

  function getCurrentFormData() {
    return {
      name: getFieldValue([
        'Name',
        'Full Name'
      ]),

      email: getFieldValue([
        'Email'
      ]),

      phone: getFieldValue([
        'Phone'
      ]),

      address: getFieldValue([
        'Address'
      ]),

      city: getFieldValue([
        'City'
      ]),

      state: getFieldValue([
        'State / Province / Region',
        'State'
      ]),

      postal: getFieldValue([
        'Postal Code',
        'Zip Code',
        'ZIP'
      ]),

      country: getFieldValue([
        'Country'
      ])
    };
  }


  /* =========================================================
     SAVE FORM DATA BEFORE SUBMIT
  ========================================================= */

  function saveCollect6Data() {
    var data = getCurrentFormData();

    try {
      sessionStorage.setItem(
        'collect6Submission',
        JSON.stringify(data)
      );
    } catch (e) {
      console.log('COLLECT 6: Unable to save submission data.');
    }
  }


  /* =========================================================
     LOAD SAVED FORM DATA
  ========================================================= */

  function getSavedCollect6Data() {
    try {
      var saved = sessionStorage.getItem('collect6Submission');

      if (!saved) {
        return null;
      }

      return JSON.parse(saved);

    } catch (e) {
      return null;
    }
  }


  /* =========================================================
     PRINT MAIL-IN FORM
     useSavedData = true  → Thank-you page
     useSavedData = false → COLLECT 6 entry page
  ========================================================= */

  function printCollect6Form(useSavedData) {

    var data;

    if (useSavedData) {
      data = getSavedCollect6Data();

      if (!data || !data.name || !data.email) {
        alert(
          'We could not retrieve your submitted information. ' +
          'Please contact PREDICTION for assistance.'
        );
        return;
      }

    } else {
      data = getCurrentFormData();

      if (!data.name || !data.email) {
        alert('Please enter your Name and Email before printing.');
        return;
      }
    }


    var name = data.name || '';
    var email = data.email || '';
    var phone = data.phone || '';
    var address = data.address || '';
    var city = data.city || '';
    var state = data.state || '';
    var zip = data.postal || '';
    var country = data.country || '';


    var locationLine = '';

    if (city) {
      locationLine += city;
    }

    if (state) {
      if (locationLine) {
        locationLine += ', ';
      }

      locationLine += state;
    }

    if (zip) {
      if (locationLine) {
        locationLine += ' ';
      }

      locationLine += zip;
    }


    var printWindow = window.open(
      '',
      'Collect6Print',
      'width=850,height=950'
    );

    if (!printWindow) {
      alert(
        'Please allow pop-ups to print your COLLECT 6 form.'
      );
      return;
    }


    var html = '';

    html += '<!DOCTYPE html>';
    html += '<html>';

    html += '<head>';
    html += '<title>COLLECT 6 Mail-In Submission Form</title>';

    html += '<style>';

    html += '@page {';
    html += 'size: Letter portrait;';
    html += 'margin: 0.5in;';
    html += '}';

    html += '* {';
    html += 'box-sizing: border-box;';
    html += '}';

    html += 'body {';
    html += 'margin:0;';
    html += 'font-family:Arial,Helvetica,sans-serif;';
    html += 'font-size:12px;';
    html += 'color:#111;';
    html += '}';

    html += '.sheet {';
    html += 'max-width:7.5in;';
    html += 'margin:0 auto;';
    html += '}';

    html += '.header {';
    html += 'text-align:center;';
    html += 'border-bottom:2px solid #111;';
    html += 'padding-bottom:15px;';
    html += '}';

    html += '.brand {';
    html += 'font-size:14px;';
    html += 'font-weight:bold;';
    html += 'letter-spacing:5px;';
    html += '}';

    html += '.collect {';
    html += 'font-size:30px;';
    html += 'font-weight:800;';
    html += 'margin-top:5px;';
    html += '}';

    html += '.subtitle {';
    html += 'font-size:12px;';
    html += 'font-weight:bold;';
    html += 'letter-spacing:1.5px;';
    html += '}';

    html += '.intro {';
    html += 'margin:16px 0;';
    html += 'padding:10px;';
    html += 'border:1px solid #999;';
    html += 'text-align:center;';
    html += '}';

    html += '.section-title {';
    html += 'font-weight:bold;';
    html += 'font-size:12px;';
    html += 'border-bottom:1px solid #111;';
    html += 'padding-bottom:4px;';
    html += 'margin-top:18px;';
    html += '}';

    html += '.row {';
    html += 'display:flex;';
    html += 'border-bottom:1px solid #ccc;';
    html += 'padding:8px 4px;';
    html += '}';

    html += '.label {';
    html += 'width:120px;';
    html += 'font-weight:bold;';
    html += '}';

    html += '.value {';
    html += 'flex:1;';
    html += '}';

    html += '.passport {';
    html += 'padding:12px 4px;';
    html += '}';

    html += '.mail-box {';
    html += 'width:70%;';
    html += 'margin:18px auto;';
    html += 'padding:14px;';
    html += 'border:2px solid #111;';
    html += 'text-align:center;';
    html += 'line-height:1.5;';
    html += '}';

    html += '.important {';
    html += 'margin-top:16px;';
    html += 'padding:10px;';
    html += 'background:#f3f3f3;';
    html += 'border-left:4px solid #111;';
    html += 'font-size:11px;';
    html += '}';

    html += '.footer {';
    html += 'text-align:center;';
    html += 'margin-top:20px;';
    html += 'padding-top:10px;';
    html += 'border-top:1px solid #aaa;';
    html += 'font-weight:bold;';
    html += '}';

    html += '</style>';
    html += '</head>';


    html += '<body>';
    html += '<div class="sheet">';


    /* HEADER */

    html += '<div class="header">';
    html += '<div class="brand">PREDICTION</div>';
    html += '<div class="collect">COLLECT 6</div>';
    html += '<div class="subtitle">';
    html += 'MAIL-IN SUBMISSION FORM';
    html += '</div>';
    html += '</div>';


    /* INTRO */

    html += '<div class="intro">';
    html += 'Please mail this form together with your ';
    html += '<strong>';
    html += 'six (6) original Passport Cards';
    html += '</strong> ';
    html += 'to complete your COLLECT 6 submission.';
    html += '</div>';


    /* CUSTOMER INFORMATION */

    html += '<div class="section-title">';
    html += 'CUSTOMER INFORMATION';
    html += '</div>';


    html += '<div class="row">';
    html += '<div class="label">Name</div>';
    html += '<div class="value">';
    html += safe(name);
    html += '</div>';
    html += '</div>';


    html += '<div class="row">';
    html += '<div class="label">Email</div>';
    html += '<div class="value">';
    html += safe(email);
    html += '</div>';
    html += '</div>';


    html += '<div class="row">';
    html += '<div class="label">Phone</div>';
    html += '<div class="value">';
    html += safe(phone);
    html += '</div>';
    html += '</div>';


    html += '<div class="row">';
    html += '<div class="label">Mailing Address</div>';
    html += '<div class="value">';

    html += safe(address);

    if (locationLine) {
      html += '<br>';
      html += safe(locationLine);
    }

    if (country) {
      html += '<br>';
      html += safe(country);
    }

    html += '</div>';
    html += '</div>';


    /* PASSPORT */

    html += '<div class="section-title">';
    html += 'PASSPORT CARDS';
    html += '</div>';

    html += '<div class="passport">';
    html += '□ ';
    html += '<strong>';
    html += 'Six (6) original PREDICTION Passport Cards ';
    html += 'are enclosed with this form.';
    html += '</strong>';
    html += '</div>';


    /* MAIL TO */

    html += '<div class="mail-box">';

    html += '<strong>MAIL TO</strong>';
    html += '<br><br>';

    html += '<strong>';
    html += 'PREDICTION Promotions Department';
    html += '</strong>';

    html += '<br>';
    html += '13455 Pumice St.';

    html += '<br>';
    html += 'Norwalk, CA 90650';

    html += '</div>';


    /* IMPORTANT */

    html += '<div class="important">';
    html += '<strong>IMPORTANT:</strong> ';

    if (useSavedData) {
      html += 'Your online submission has already been received. ';
      html += 'Please mail this printed form together with your ';
      html += '<strong>six (6) Passport Cards</strong>.';

    } else {
      html += 'After printing this form, return to the ';
      html += 'COLLECT 6 page and click ';
      html += '<strong>Submit</strong> ';
      html += 'to complete your online submission.';
    }

    html += '</div>';


    /* FOOTER */

    html += '<div class="footer">';
    html += 'Thank you for being a PREDICTION VIP!';
    html += '</div>';


    html += '</div>';
    html += '</body>';
    html += '</html>';


    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();


    setTimeout(function () {
      printWindow.focus();
      printWindow.print();
    }, 500);
  }


  /* =========================================================
     FIND SUBMIT BUTTON
  ========================================================= */

  function findSubmitButton() {

    var buttons = document.querySelectorAll(
      'button, input[type="submit"]'
    );

    for (var i = 0; i < buttons.length; i++) {

      var text = (
        buttons[i].innerText ||
        buttons[i].value ||
        ''
      )
        .trim()
        .toLowerCase();

      if (text === 'submit') {
        return buttons[i];
      }
    }

    return null;
  }


  /* =========================================================
     ADD PRINT BUTTON BEFORE SUBMIT
  ========================================================= */

  function addPrintButton() {

    var submitButton = findSubmitButton();

    /*
      No COLLECT 6 form on this page.
      This is normal on Thank-you page.
    */
    if (!submitButton) {
      return;
    }


    /*
      Attach SAVE action to Submit
    */

    if (!submitButton.dataset.collect6SaveAttached) {

      submitButton.addEventListener(
        'click',
        function () {
          saveCollect6Data();
        },
        true
      );

      submitButton.dataset.collect6SaveAttached = 'true';
    }


    /*
      If Print button already exists,
      do not create another one.
    */

    if (document.getElementById('collect6-print-button')) {
      return;
    }


    var wrapper = document.createElement('div');

    wrapper.id = 'collect6-print-button';
    wrapper.style.width = '100%';
    wrapper.style.margin = '14px 0 8px';


    var button = document.createElement('button');

    button.type = 'button';
    button.innerHTML = '🖨️ Print Your Completed Form';

    button.style.width = '100%';
    button.style.background = '#000';
    button.style.color = '#fff';
    button.style.border = 'none';
    button.style.padding = '14px 20px';
    button.style.fontSize = '15px';
    button.style.cursor = 'pointer';


    button.addEventListener(
      'click',
      function () {
        printCollect6Form(false);
      }
    );


    wrapper.appendChild(button);


    submitButton.parentNode.insertBefore(
      wrapper,
      submitButton
    );
  }


  /* =========================================================
     THANK-YOU PAGE PRINT BUTTON
  ========================================================= */

  function setupThankYouPrintButton() {

    var button = document.getElementById(
      'collect6-thankyou-print'
    );

    if (!button) {
      return;
    }


    if (button.dataset.collect6PrintAttached) {
      return;
    }


    button.addEventListener(
      'click',
      function () {
        printCollect6Form(true);
      }
    );


    button.dataset.collect6PrintAttached = 'true';
  }


  /* =========================================================
     INITIALIZE
  ========================================================= */

  function initializeCollect6() {

    addPrintButton();

    setupThankYouPrintButton();


    /*
      Powerful Form Builder loads dynamically.
      Try again for several seconds.
    */

    var attempts = 0;

    var timer = setInterval(function () {

      attempts++;

      addPrintButton();

      setupThankYouPrintButton();


      if (attempts >= 20) {
        clearInterval(timer);
      }

    }, 500);
  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initializeCollect6
    );

  } else {

    initializeCollect6();

  }

})();